// extracted by mini-css-extract-plugin
export default {"listItem":"InUWf","tick":"sk1dL"};